export type CatalogPrefetchEnvironment = {
  visible: boolean;
  online: boolean;
  saveData: boolean;
  effectiveType: string;
};

const CONSTRAINED_CONNECTIONS = new Set(["slow-2g", "2g", "3g"]);

/**
 * Catalog speculation is allowed only after a shopper-intent signal (the
 * caller owns that signal) and only when it will not consume a constrained
 * connection in the background.
 */
export const canPrefetchCatalogForIntent = (
  environment: CatalogPrefetchEnvironment
): boolean =>
  environment.visible &&
  environment.online &&
  !environment.saveData &&
  !CONSTRAINED_CONNECTIONS.has(environment.effectiveType.toLowerCase());

export const readCatalogPrefetchEnvironment =
  (): CatalogPrefetchEnvironment => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return {
        visible: false,
        online: false,
        saveData: false,
        effectiveType: "",
      };
    }

    const connection = (navigator as any).connection;
    return {
      visible: document.visibilityState === "visible",
      online: navigator.onLine !== false,
      saveData: connection?.saveData === true,
      effectiveType: String(connection?.effectiveType || ""),
    };
  };
